import type { AnnotationLabelT } from '../../../common/types/types';
import type { AnnotationT } from '../../labelling/types';
import { createKeyFrame } from '../../labelling/utils';
import type { FramePayload, MetadataPayload } from '../studio-store/types';
import { resolveAnnotationType } from './resolve-annotation-type';

/**
 * Temporary utility for the dual-write phase. Reconstructs a full AnnotationT
 * from a FramePayload + MetadataPayload for use with WRITE_ANNOTATION dispatches.
 *
 * Will be removed in PR 11 when annotationFramesAtom is deleted and
 * WRITE_ANNOTATION accepts FramePayload directly.
 */
export function reconstructAnnotationFromFramePayload(framePayload: FramePayload, metadata: MetadataPayload, annotationIdToLabelMap: Map<string, AnnotationLabelT>): AnnotationT {
  const label = annotationIdToLabelMap.get(metadata.annotationId) ?? {
    title: metadata.labelId,
    style: {
      strokeColor: '',
      fillColor: '',
      fillOpacity: 0,
      strokeWidth: 1
    }
  };
  return ({
    annotationType: resolveAnnotationType(label, metadata.annotationType),
    annotationLabel: label,
    data: framePayload.geometry,
    hidden: false,
    locked: false,
    keyFrame: createKeyFrame(framePayload.isKeyFrame, framePayload.keyFrameType ?? 'MANUAL'),
    metadata: framePayload.mlState ? {
      mlData: {
        state: framePayload.mlState
      }
    } : undefined
  } as AnnotationT);
}